import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import "./Playlist.css";
import FogandFire from "./images/FogandFire (Medium).png";
import Fairytale from "./images/Fairytale (Medium).png";
import Galaxy from "./images/Galaxy (Medium).png";
import Lullaby from "./images/Lullaby (Medium).png";
import Storybook from "./images/Storybook1 (Medium).png";
import AlltheLittleThings from "./images/AlltheLittleThings (Medium).png";
import ChasingCars from "./images/ChasingCars (Medium).png";
import LoveWeaves from "./images/LoveWeaves (Medium).png"
import Perfect from "./images/Perfect (Medium).png";
import WhyDidWeEver from "./images/WhyDidWeEver1 (Medium).png";
import Sandglass from "./images/Sandglass (Medium).png";
import Havoc from "./images/Havoc (Medium).png";
import Thief from "./images/Thief1 (Medium).png";
import Villain from "./images/Villain (Medium).png";
import Warrior2 from "./images/Warrior2 (Medium).png";
import Gallery from "./Gallery";

import SoundCloudPlayer from './SoundCloudPlayer';
import Modal from "./Modal";

function Playlist(props) {

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedTrack, setSelectedTrack] = useState(null);
  // const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  const musiclist = [
    {
      name: 'Fog and Fire',
      imageUrl: FogandFire,
      url: 'https://soundcloud.com/aethelmusic/fog-and-fire?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing',
      identifier: 1424916019
    },
    {
      name: 'Fairytale',
      imageUrl: Fairytale,
      url: 'https://soundcloud.com/aethelmusic/fairytale?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing',
      identifier: 1424937448
    },
    {
      name: 'Lullaby',
      imageUrl: Lullaby,
      url: 'https://soundcloud.com/aethelmusic/lullabye-project-demo?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing',
      identifier: 1132211719
    },
    {
      name: 'Galaxy',
      imageUrl: Galaxy,
      url: 'https://soundcloud.com/aethelmusic/galaxy-1?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing',
      identifier: 1289771581
    },
    {
      name: 'Storybook',
      imageUrl: Storybook,
      url: 'https://soundcloud.com/aethelmusic/warrior?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing',
      identifier: 1273953145
    },
    {
      name: 'All the Little Things',
      imageUrl: AlltheLittleThings,
      url: 'https://soundcloud.com/aethelmusic/all-the-little-things?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing',
      identifier: 1274824957
    },
    {
      name: 'Love that Weaves Warriors',
      imageUrl: LoveWeaves,
      url: 'https://soundcloud.com/aethelmusic/love-that-weaves-warriors?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing',
      identifier: 1163399023
    },
    {
      name: 'ChasingCars',
      imageUrl: ChasingCars,
      url: 'https://soundcloud.com/aethelmusic/chasing-cars-cover?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing',
      identifier: 1299816766
    },
    {
      name: 'Why Did We Ever',
      imageUrl: WhyDidWeEver,
      url: 'https://soundcloud.com/aethelmusic/why-did-we-ever?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing',
      identifier: 1274805421
    },
    {
      name: 'Perfect',
      imageUrl: Perfect,
      url: 'https://soundcloud.com/aethelmusic/perfect-live?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing',
      identifier: 1437093787
    },
    {
      name: 'Sandglass',
      imageUrl: Sandglass,
      url: 'https://soundcloud.com/aethelmusic/sandglass?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing',
      identifier: 1059110236
    },
    {
      name: 'Havoc',
      imageUrl: Havoc,
      url: 'https://soundcloud.com/aethelmusic/havoc?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing',
      identifier: 1479987805
    },
    {
      name: 'Thief',
      imageUrl: Thief,
      url: 'https://soundcloud.com/aethelmusic/thief-rough-demo?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing',
      identifier: 1459542340
    },
    {
      name: 'Villain',
      imageUrl: Villain,
      url: 'https://soundcloud.com/aethelmusic/villain-phone-demo?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing',
      identifier: 160393675
    },
    {
      name: 'Warrior',
      imageUrl: Warrior2,
      url: 'https://soundcloud.com/aethelmusic/warrior?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing',
      identifier: 1273953145
    },
  ];

  const handleTrackClick = (track) => {
    setSelectedTrack(track);
    setModalOpen(true);

  };

  const closeModal = () => {
    setSelectedTrack(null);
    setModalOpen(false);
  };

  return (
    <div style={{ marginTop: 0 }}>
      <Helmet>
        <title>Playlist Page</title>
        <meta name="description" content="Listen to Aethel's music playlist here with individual songs and SoundCloud Embed for her album /'Out of the Fog/'" />

        {/* Page-Specific Open Graph Tags */}
        <meta property="og:title" content="Playlist Page - Aethel Music" />
        <meta property="og:description" content="Listen to Aethel's music playlist here with individual songs and SoundCloud Embed for her album /'Out of the Fog/'" />
        <meta property="og:image" content="%PUBLIC_URL%/images/BiopicMedium.png"  />
        <meta property="og:url" content="https://aethel.vercel.app/playlist" />

        {/* Page-Specific Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Playlist Page - Aethel Music" />
        <meta name="twitter:description" content="Listen to Aethel's music playlist here with individual songs and SoundCloud Embed for her album /'Out of the Fog/'" />
        <meta name="twitter:image" content="%PUBLIC_URL%/images/BiopicMedium.png"  />
      </Helmet>
      <div className="pagetitle">
        <div className="title"><h1>Æthel Playlist</h1></div>
      </div>
      <div className="playlist">
        {musiclist.map((playlist, index) => (
          <Gallery key={index} playlist={playlist} onTrackClick={() => handleTrackClick(playlist)} />
        ))}

      </div>

      <div className="space"></div>

      <Modal isOpen={modalOpen} onClose={closeModal} imageUrl={selectedTrack?.imageUrl} name={selectedTrack?.name} />

      {selectedTrack && (
        <div id='soundcloud-embed' className='soundcloud selected'>
          <SoundCloudPlayer
            key={selectedTrack.identifier}
            trackUrl={selectedTrack.url}
            trackTitle={selectedTrack.name}
            isSelected={true}
            onToggle={closeModal}
            width="60%"
            height="500px"
          />
        </div>

      )}
      <div class="soundcloud-album">
        <iframe
          title="SoundCloud Player"
          width="100%"
          height="400"
          scrolling="no"
          frameborder="no"
          allow="autoplay"
          src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1680375615&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true">
        </iframe>
      </div>
    </div>
  );
}

export default Playlist;
